import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DoneOutlineOutlinedIcon from "@mui/icons-material/DoneOutlineOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { apiUser } from "../ApiCall";

export interface Props {
  updateId: any;
  fieldText: string;
  fieldLabel: string;
  updateLabel: string;
}

const TextToUpdateField = ({
  updateId,
  fieldText,
  fieldLabel,
  updateLabel,
}: Props) => {
  const [storedValue, setStoredValue] = useState(fieldText);
  const [itemValue, setItemValue] = useState(fieldText);
  const [showInput, setShowInput] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState<"error" | "success">("success");

  useEffect(() => {
    setStoredValue(fieldText);
    setItemValue(fieldText);
  }, [fieldText]);

  const handleToggleInput = () => {
    if (showInput) {
      setItemValue(storedValue);
      setShowInput(false);
    } else {
      setShowInput(true);
    }
  };

  const updateData = async () => {
    if (!itemValue.trim() || itemValue.trim() === storedValue.trim()) {
      return;
    }

    const updatePayload: any = {};
    if (updateLabel === "name") {
      const parts = itemValue.split(" ");
      updatePayload.firstName = parts[0] || "";
      updatePayload.lastName = parts.slice(1).join(" ") || "";
    } else if (updateLabel === "document") {
      updatePayload.document = itemValue.replace(/\D/g, "");
    } else {
      updatePayload[updateLabel] = itemValue;
    }
    
    try {
      await apiUser.put(`/user/${updateId}`, updatePayload);
      setSnackMessage("Perfil Salvo");
      setSnackSeverity("success");
      setOpenSnack(true);
      setStoredValue(itemValue);
      setShowInput(false);
    } catch (error) {
      console.error("Erro na atualização", error);
      setSnackMessage("Erro ao salvar dados.");
      setSnackSeverity("error");
      setOpenSnack(true);
    }
  };

  return (
    <FormControl variant="outlined" className="text-to-input">
      <InputLabel htmlFor="outlined-adornment">{fieldLabel}</InputLabel>
      <OutlinedInput
        id="outlined-adornment"
        type="text"
        value={itemValue}
        disabled={!showInput}
        onChange={(e) => setItemValue(e.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={showInput ? "Cancelar" : "Editar"}
              onClick={handleToggleInput}
              edge="end"
            >
              {showInput ? (
                <HighlightOffOutlinedIcon className="warn-icon" />
              ) : (
                <CreateOutlinedIcon />
              )}
            </IconButton>
            {showInput && (
              <IconButton
                aria-label="Salvar"
                className="done-icon"
                onClick={updateData}
                edge="end"
                disabled={
                  !itemValue.trim() || itemValue.trim() === storedValue.trim()
                }
              >
                <DoneOutlineOutlinedIcon
                  sx={{
                    color:
                      itemValue.trim() &&
                      itemValue.trim() !== storedValue.trim()
                        ? "green"
                        : "gray",
                  }}
                />
              </IconButton>
            )}
          </InputAdornment>
        }
        label={fieldLabel}
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnack}
        autoHideDuration={3000}
        onClose={() => setOpenSnack(false)}
      >
        <Alert
          onClose={() => setOpenSnack(false)}
          severity={snackSeverity}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </FormControl>
  );
};

export default TextToUpdateField;
